import { DESCRIPTION_TYPES, OVERVIEW_EVENTS, VAR_EVENTS, VAR_EVENTS_LABELS } from "@ihs-widget/utils/enums";

export const switchDescription = (event_type: string, description: string) => {
    if (description === DESCRIPTION_TYPES.GOAL) {
        switch(event_type) {
            case VAR_EVENTS.VAR:
                return VAR_EVENTS_LABELS.VAR_GOAL;
            case VAR_EVENTS.VAR_CHECK:
                return VAR_EVENTS_LABELS.VAR_CHECK_GOAL;
            case VAR_EVENTS.VAR_DECLINED:
                return VAR_EVENTS_LABELS.VAR_DECLINED_GOAL;
            default:
                return VAR_EVENTS_LABELS.EMPTY;
        }
    } else if (description === DESCRIPTION_TYPES.PENALTY) {
        switch(event_type) {
            case VAR_EVENTS.VAR:
                return VAR_EVENTS_LABELS.VAR_PENALTY;
            case VAR_EVENTS.VAR_CHECK:
                return VAR_EVENTS_LABELS.VAR_CHECK_PENALTY;
            case VAR_EVENTS.VAR_DECLINED:
                return VAR_EVENTS_LABELS.VAR_DECLINED_PENALTY;
            default:
                return VAR_EVENTS_LABELS.EMPTY;
        }
    }
    return VAR_EVENTS_LABELS.EMPTY;
}
